module.exports = __webpack_public_path__ + "img/home.9c8fd687.png";